import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/EmptyState/empty-state';
export var EmptyStateIcon = function EmptyStateIcon(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      IconComponent = _a.icon,
      AnyComponent = _a.component,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'icon' : _a$variant,
      props = __rest(_a, ["className", "icon", "component", "variant"]);

  var classNames = css(styles.emptyStateIcon, className);
  return variant === 'icon' ? React.createElement(IconComponent, Object.assign({
    className: classNames
  }, props, {
    "aria-hidden": "true"
  })) : React.createElement("div", {
    className: classNames
  }, React.createElement(AnyComponent, null));
};